<p-treeSelect
  [options]="tree"
  [(ngModel)]="selectedNode"
  selectionMode="single"
  [disabled]="disabled"
  [showClear]="true"
  [filter]="true"
  filterBy="label,key"
  [tabindex]="tabindex"
  [placeholder]="placeholder"
  appendTo="body"
  [style]="{ width: '100%' }"
  scrollHeight="40vh"
  (onNodeSelect)="onNodeSelect($event)"
  (onClear)="onClear()"
  (onFilter)="onFilter($event)"
  (onShow)="onPanelShow()"
  (onHide)="onPanelHide()"
>
  <ng-template pTemplate="value" let-value>
    <span *ngIf="selectedNode">{{ displayLabel }}</span>
    <span *ngIf="!selectedNode" class="source-tree-select-placeholder">
      {{ placeholder }}
    </span>
  </ng-template>

  <ng-template pTemplate="empty">
    <button
      *ngIf="searchTerm; else noResults"
      type="button"
      class="source-tree-select-add-custom p-link"
      (click)="enterCustomValue()"
    >
      Add &ldquo;{{ searchTerm }}&rdquo; as a new source
    </button>
    <ng-template #noResults>
      <span class="source-tree-select-empty">No sources found</span>
    </ng-template>
  </ng-template>
</p-treeSelect>
